import isId from '../isId';
import isServer from '../isServer';

const isStudio = () => {
  if (isServer()) return false;

  const splittedPath = location.pathname?.replace('/', '').split('/');

  return splittedPath?.[0] === 'live' && isId(splittedPath?.[1]);
};

export default isStudio;
